import { Component, Input, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { tap } from 'rxjs/operators';

import { ProfileMessageDialogComponent } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog.component';

import { Account } from '@libs/src/models/account.model';
import { Profile } from '@main-client/src/app/profile/profile';

import { ProfileMessageStatus } from '../../app.state';

import { GroupMembershipService } from '../../core/group-membership.service';

import get from 'lodash-es/get';
import isEqual from 'lodash-es/isEqual';
import some from 'lodash-es/some';

enum ACTION_MODES {
  conversation = 'CONVERSATION',
  manual = 'MANUAL',
  none = '',
  introduction = 'INTRODUCTION',
}

@Component({
  selector: 'app-profile-action',
  templateUrl: './profile-action.component.html',
})
export class ProfileActionComponent implements OnChanges {
  @Input() analyticName: string;
  @Input() profile: Profile;
  @Input() user: Account;
  ACTION_MODES = ACTION_MODES;
  canAction: boolean;
  matchGroup: any;
  ProfileMessageStatus = ProfileMessageStatus;
  messageStatus = ProfileMessageStatus.none;
  isLoading = false;
  matchIsActioned = false;

  constructor(
    private dialog: MatDialog,
    private groupMembershipService: GroupMembershipService,
  ) {}

  ngOnChanges() {
    this.matchIsActioned = some(
      get(this.profile, 'match.accounts', []),
      (matchAccount: any) => isEqual(matchAccount.status, 'active'),
    );
    this.matchGroup = this.groupMembershipService.getMembership(
      this.user.groups,
      this.profile?.match?.group as string,
    );
    this.canAction = [this.profile, this.user]
      .map((item: any) => item.status)
      .every((status) => isEqual('active', status));
  }

  changeMessageMode(action: ProfileMessageStatus) {
    this.messageStatus = action;
  }

  get actionMode(): string {
    if (!this.canAction) {
      return this.ACTION_MODES.none;
    }

    if (this.profile.match) {
      return this.ACTION_MODES.introduction;
    }

    if (this.profile.conversationId) {
      return this.ACTION_MODES.conversation;
    }

    return this.ACTION_MODES.manual;
  }

  openMessageDialog(profile: Account, user: Account) {
    this.isLoading = true;
    const config: any = {
      disableClose: true,
      data: {
        profile,
        user,
        analyticNameSuffix: this.analyticName,
      },
      maxWidth: '500px',
      width: '95vw',
    };
    this.dialog
      .open(ProfileMessageDialogComponent, config)
      .afterClosed()
      .pipe(
        tap((data: any) => {
          this.isLoading = false;
          if (!data) {
            return;
          }
          this.changeMessageMode(data);
        }),
      )
      .subscribe();
  }
}
